import { OrderSigned } from '../../domain/data';
import { OrderSignedInterface } from '../../../core';

export const mapCommonResponse = (resp: any): boolean => {
    if (!resp || (resp.Status !== 'OK' && resp.Status !== 'ok' && resp.Status !== '')) {
        throw new Error(resp ? resp.Status : 'error.general');
    } else {
        return true;
    }
};

export const mapOrderSigned = (resp: any): OrderSignedInterface => {
    if (!resp || (resp.Status !== 'OK' && resp.Status !== 'ok' && resp.Status !== '')) {
        throw new Error(resp ? resp.Status : 'error.general');
    } else {
        return new OrderSigned(resp.XmlSignature || resp.xmlSignature || undefined);
    }
};
